import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/consulta-cep`;

export const buscarCep = (cep) => {
	return api.get(`${BASE_URL}?cep=${cep}`);
};